import { Component } from '@angular/core';
import { LandingHero } from '../../shared/components/landing-hero/landing-hero';
import { Counters } from '../../shared/components/landing-components/counters/counters';
import { Services } from '../../shared/components/landing-components/services/services';
import { Industries } from '../../shared/components/landing-components/industries/industries';
import { Partners } from '../../shared/components/landing-components/partners/partners';
import { Team } from '../../shared/components/landing-components/team/team';
import { ContactSection } from '../../shared/components/landing-components/contact-section/contact-section';
import { Feedback } from '../../shared/components/landing-components/feedback/feedback';
import { Projects } from '../../shared/components/landing-components/projects/projects';
import { AnimatedBackground } from '../../shared/components/animated-background/animated-background';
import { Counter, Service } from '../../core/interfaces';

@Component({
  selector: 'app-landing',
  imports: [
    LandingHero,
    Counters,
    Services,
    Industries,
    Partners,
    Team,
    ContactSection,
    Feedback,
    Projects,
    AnimatedBackground,
  ],

  templateUrl: './landing.html',
  styleUrl: './landing.css',
  schemas: [],
})
export class Landing {
  counterItems: Counter[] = [
    {
      title: '100 Project',
      body: 'Real solutions built for real businesses, from startups to enterprises.',
    },
    {
      title: '10 Industries',
      body: 'We tailor made smart, modern, & scalable solutions to meet your unique needs.',
    },
    {
      title: '5 years',
      body: 'A proven track record in delivering smart, scalable, and advanced digital products.',
    },
  ];
  items: Service[] = [
    {
      imageSrc: 'images/services/_x36_5.png',
      title: 'Web Development',
      description:
        'We design and develop fast, responsive, and user-focused websites that bring your brand to life.',
      loading: 'eager',
      route: "/services/development"
    },
    {
      imageSrc: 'images/services/UX.png',
      title: 'UI/UX Services',
      description:
        'Beautiful meets functional — we design experiences your users will love, remember, and keep coming back to.',
      loading: 'lazy',
      route: "/services/development"

    },
    {
      imageSrc: 'images/services/Vector (24).png',
      title: 'Digital Marketing',
      description:
        'We help you reach the right audience, at the right time, through SEO, SEM, and smart strategy.',
      loading: 'lazy',
      route: "/services/digital-marketing"

    },
    {
      imageSrc: 'images/services/business solutions.png',
      title: 'Business Solutions',
      description:
        'We build systems that automate operations, simplify workflows, and help teams work smarter.',
      loading: 'lazy',
      route: "/services/bussiness"

    },
    {
      imageSrc: 'images/services/_x36_5.png',
      title: 'Web Development',
      description:
        'We design and develop fast, responsive, and user-focused websites that bring your brand to life.',
      loading: 'lazy',
      route: "services/development"

    },
    {
      imageSrc: 'images/services/UX.png',
      title: 'UI/UX Services',
      description:
        'Beautiful meets functional — we design experiences your users will love, remember, and keep coming back to.',
      loading: 'lazy',
      route: "services/development"

    },
    {
      imageSrc: 'images/services/Vector (24).png',
      title: 'Digital Marketing',
      description:
        'We help you reach the right audience, at the right time, through SEO, SEM, and smart strategy.',
      loading: 'lazy',
      route: "/services/digital-marketing"

    },
    {
      imageSrc: 'images/services/business solutions.png',
      title: 'Business Solutions',
      description:
        'We build systems that automate operations, simplify workflows, and help teams work smarter.',
      loading: 'lazy',
      route: "/services/bussiness"

    },
    {
      imageSrc: 'images/services/_x36_5.png',
      title: 'Web Development',
      description:
        'We design and develop fast, responsive, and user-focused websites that bring your brand to life.',
      loading: 'lazy',
      route: "services/development"

    },
    {
      imageSrc: 'images/services/UX.png',
      title: 'UI/UX Services',
      description:
        'Beautiful meets functional — we design experiences your users will love, remember, and keep coming back to.',
      loading: 'lazy',
      route: "/services/development"

    },
    {
      imageSrc: 'images/services/Vector (24).png',
      title: 'Digital Marketing',
      description:
        'We help you reach the right audience, at the right time, through SEO, SEM, and smart strategy.',
      loading: 'lazy',
      route: "/services/digital-marketing"

    },
    {
      imageSrc: 'images/services/business solutions.png',
      title: 'Business Solutions',
      description:
        'We build systems that automate operations, simplify workflows, and help teams work smarter.',
      loading: 'lazy',
      route: "/services/bussiness"

    },
  ];
}
